function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { func, dom } from '../util';
import Animate from './animate';

var noop = function noop() {};

var getStyle = dom.getStyle;

var Expand = /*#__PURE__*/function (_Component) {
  _inherits(Expand, _Component);

  var _super = _createSuper(Expand);

  function Expand(props) {
    var _this;

    _classCallCheck(this, Expand);

    _this = _super.call(this, props);
    func.bindCtx(_assertThisInitialized(_this), ['beforeEnter', 'onEnter', 'afterEnter', 'beforeLeave', 'onLeave', 'afterLeave']);
    return _this;
  }

  _createClass(Expand, [{
    key: "beforeEnter",
    value: function beforeEnter(node) {
      if (this.leaving) {
        this.afterLeave(node);
      }

      this.cacheCurrentStyle(node);
      this.cacheComputedStyle(node);
      this.setCurrentStyleToZero(node);
      this.props.beforeEnter(node);
    }
  }, {
    key: "onEnter",
    value: function onEnter(node) {
      this.setCurrentStyleToComputedStyle(node);
      this.props.onEnter(node);
    }
  }, {
    key: "afterEnter",
    value: function afterEnter(node) {
      this.restoreCurrentStyle(node);
      this.props.afterEnter(node);
    }
  }, {
    key: "beforeLeave",
    value: function beforeLeave(node) {
      this.leaving = true;
      this.cacheCurrentStyle(node);
      this.cacheComputedStyle(node);
      this.setCurrentStyleToComputedStyle(node);
      this.props.beforeLeave(node);
    }
  }, {
    key: "onLeave",
    value: function onLeave(node) {
      this.setCurrentStyleToZero(node);
      this.props.onLeave(node);
    }
  }, {
    key: "afterLeave",
    value: function afterLeave(node) {
      this.leaving = false;
      this.restoreCurrentStyle(node);
      this.props.afterLeave(node);
    }
  }, {
    key: "cacheCurrentStyle",
    value: function cacheCurrentStyle(node) {
      this.styleBorderTopWidth = node.style.borderTopWidth;
      this.stylePaddingTop = node.style.paddingTop;
      this.styleHeight = node.style.height;
      this.stylePaddingBottom = node.style.paddingBottom;
      this.styleBorderBottomWidth = node.style.borderBottomWidth;
    }
  }, {
    key: "cacheComputedStyle",
    value: function cacheComputedStyle(node) {
      this.borderTopWidth = getStyle(node, 'borderTopWidth');
      this.paddingTop = getStyle(node, 'paddingTop');
      this.height = node.offsetHeight;
      this.paddingBottom = getStyle(node, 'paddingBottom');
      this.borderBottomWidth = getStyle(node, 'borderBottomWidth');
    }
  }, {
    key: "setCurrentStyleToZero",
    value: function setCurrentStyleToZero(node) {
      node.style.borderTopWidth = '0px';
      node.style.paddingTop = '0px';
      node.style.height = '0px';
      node.style.paddingBottom = '0px';
      node.style.borderBottomWidth = '0px';
    }
  }, {
    key: "setCurrentStyleToComputedStyle",
    value: function setCurrentStyleToComputedStyle(node) {
      node.style.borderTopWidth = "".concat(this.borderTopWidth, "px");
      node.style.paddingTop = "".concat(this.paddingTop, "px");
      node.style.height = "".concat(this.height, "px");
      node.style.paddingBottom = "".concat(this.paddingBottom, "px");
      node.style.borderBottomWidth = "".concat(this.borderBottomWidth, "px");
    }
  }, {
    key: "restoreCurrentStyle",
    value: function restoreCurrentStyle(node) {
      node.style.borderTopWidth = this.styleBorderTopWidth;
      node.style.paddingTop = this.stylePaddingTop;
      node.style.height = this.styleHeight;
      node.style.paddingBottom = this.stylePaddingBottom;
      node.style.borderBottomWidth = this.styleBorderBottomWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animation = _this$props.animation,
          others = _objectWithoutProperties(_this$props, ["animation"]);

      var newAnimation = animation || 'expand';
      return /*#__PURE__*/React.createElement(Animate, _extends({}, others, {
        animation: newAnimation,
        beforeEnter: this.beforeEnter,
        onEnter: this.onEnter,
        afterEnter: this.afterEnter,
        beforeLeave: this.beforeLeave,
        onLeave: this.onLeave,
        afterLeave: this.afterLeave
      }));
    }
  }]);

  return Expand;
}(Component);

_defineProperty(Expand, "propTypes", {
  animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  beforeEnter: PropTypes.func,
  onEnter: PropTypes.func,
  afterEnter: PropTypes.func,
  beforeLeave: PropTypes.func,
  onLeave: PropTypes.func,
  afterLeave: PropTypes.func
});

_defineProperty(Expand, "defaultProps", {
  beforeEnter: noop,
  onEnter: noop,
  afterEnter: noop,
  beforeLeave: noop,
  onLeave: noop,
  afterLeave: noop
});

export { Expand as default };